import React from 'react';

const ComputerVision = () => {
    return (
        <div>
            Sorry, this page is not ready yet
        </div>
    );
};

export default ComputerVision;